import "../sass/project.scss";

/* Project specific Javascript goes here. */
import * as bootstrap from "bootstrap";

// Attach bootstrap to the global window object
window.bootstrap = bootstrap;
